var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53286",
    "data-name": "Rectangle 53286",
    width: 100,
    height: 100,
    transform: "translate(-0.5)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146966",
    "data-name": "Group 146966",
    transform: "translate(0.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50322",
    "data-name": "Path 50322",
    d: "M27.633,12.532h46.99V6.658a3.927,3.927,0,0,0-3.916-3.916H31.549a3.927,3.927,0,0,0-3.916,3.916v5.874Z",
    transform: "translate(23.042 2.225)",
    fill: "#e3eaef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50323",
    "data-name": "Path 50323",
    d: "M61.334,11.931a3.927,3.927,0,0,0-3.916-3.916H18.259a3.927,3.927,0,0,0-3.916,3.916v5.874h46.99V11.931Z",
    transform: "translate(11.661 6.742)",
    fill: "#e3eaef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50324",
    "data-name": "Path 50324",
    d: "M25.725,23.079v-9.79H4.971A3.927,3.927,0,0,0,1.055,17.2v5.874Z",
    transform: "translate(0.28 11.258)",
    fill: "#e3eaef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50325",
    "data-name": "Path 50325",
    d: "M25.725,18.563H1.055v56.78a3.927,3.927,0,0,0,3.916,3.916H44.129a3.927,3.927,0,0,0,3.916-3.916V69.468h-18.4a3.927,3.927,0,0,1-3.916-3.916V18.563Z",
    transform: "translate(0.28 15.774)",
    fill: "#e3eaef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50326",
    "data-name": "Path 50326",
    d: "M14.344,23.079v46.99a3.927,3.927,0,0,0,3.916,3.916H57.418a3.927,3.927,0,0,0,3.916-3.916V13.289H14.344Z",
    transform: "translate(11.661 11.258)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50327",
    "data-name": "Path 50327",
    d: "M41.463,17.806V68.711H62.217A3.927,3.927,0,0,0,66.133,64.8V8.016H37.547a3.927,3.927,0,0,1,3.916,3.916Z",
    transform: "translate(31.532 6.742)",
    fill: "#e3eaef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50328",
    "data-name": "Path 50328",
    d: "M94.372,1.688H55.214A5.88,5.88,0,0,0,49.34,7.561v3.916h-18.8a5.88,5.88,0,0,0-5.874,5.874v3.916H5.874A5.88,5.88,0,0,0,0,27.141V89.795a5.88,5.88,0,0,0,5.874,5.874H45.032a5.88,5.88,0,0,0,5.874-5.874V85.879H69.7A5.88,5.88,0,0,0,75.576,80V76.089h18.8a5.88,5.88,0,0,0,5.874-5.874V7.561A5.881,5.881,0,0,0,94.372,1.688ZM53.256,7.561A1.96,1.96,0,0,1,55.214,5.6H94.372A1.96,1.96,0,0,1,96.33,7.561v3.916H53.256ZM5.874,25.183h18.8v5.874H3.916V27.141A1.96,1.96,0,0,1,5.874,25.183ZM46.99,89.795a1.96,1.96,0,0,1-1.958,1.958H5.874a1.96,1.96,0,0,1-1.958-1.958V34.973H24.67V46.72H14.293a1.958,1.958,0,1,0,0,3.916H24.67v3.916H14.293a1.958,1.958,0,0,0,0,3.916H24.67v3.916H14.293a1.958,1.958,0,1,0,0,3.916H24.67v3.916H14.293a1.958,1.958,0,0,0,0,3.916H24.67v3.916H14.293a1.958,1.958,0,0,0,0,3.916H24.67A1.97,1.97,0,0,0,25,81.936a5.884,5.884,0,0,0,5.548,3.943H46.991v3.916ZM69.7,81.963H30.544A1.96,1.96,0,0,1,28.586,80V25.183H41.312a1.958,1.958,0,1,0,0-3.916H28.586V17.351a1.96,1.96,0,0,1,1.958-1.958H69.7a1.96,1.96,0,0,1,1.958,1.958v3.916H58.933a1.958,1.958,0,1,0,0,3.916H71.66V80A1.96,1.96,0,0,1,69.7,81.963ZM96.33,70.215a1.96,1.96,0,0,1-1.958,1.958h-18.8v-9.79H85.953a1.958,1.958,0,0,0,0-3.916H75.576V54.552H85.953a1.958,1.958,0,1,0,0-3.916H75.576V46.72H85.953a1.958,1.958,0,1,0,0-3.916H75.576V38.888H85.953a1.958,1.958,0,1,0,0-3.916H75.576V31.057H85.953a1.958,1.958,0,1,0,0-3.916H75.576v-9.79a5.853,5.853,0,0,0-.335-1.958H96.33Z",
    transform: "translate(-0.623 1.322)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50329",
    "data-name": "Path 50329",
    d: "M30.944,31.761a11.208,11.208,0,0,0-7.978,3.3,1.958,1.958,0,1,0,2.769,2.769,7.366,7.366,0,0,1,10.418,0,1.958,1.958,0,0,0,2.769-2.769A11.208,11.208,0,0,0,30.944,31.761Z",
    transform: "translate(18.555 27.077)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50330",
    "data-name": "Path 50330",
    d: "M25.537,33.148a1.958,1.958,0,0,0,2.769-2.769l-1.552-1.553,1.552-1.552a1.958,1.958,0,0,0-2.769-2.769l-1.552,1.553-1.552-1.553a1.958,1.958,0,0,0-2.769,2.769l1.553,1.552-1.553,1.553a1.958,1.958,0,1,0,2.769,2.769L23.984,31.6Z",
    transform: "translate(15.726 20.372)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50331",
    "data-name": "Path 50331",
    d: "M38.853,24.505a1.959,1.959,0,0,0-2.769,0l-1.552,1.553-1.552-1.553a1.958,1.958,0,0,0-2.769,2.769l1.553,1.552L30.21,30.379a1.958,1.958,0,1,0,2.769,2.769L34.531,31.6l1.552,1.552a1.958,1.958,0,0,0,2.769-2.769L37.3,28.827l1.553-1.552A1.958,1.958,0,0,0,38.853,24.505Z",
    transform: "translate(24.758 20.372)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50332",
    "data-name": "Path 50332",
    d: "M27.9,16.15a1.958,1.958,0,1,0,0-3.916h0a1.958,1.958,0,0,0,0,3.916Z",
    transform: "translate(21.597 10.355)",
    fill: "#80838e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.3d01406cc11f7c8dca80e95bc1ee4dea.svg";
export { ForwardRef as ReactComponent };